import styled from 'styled-components';

export const Wrapper = styled.section`
  margin-top: -300px;
`;

export const CtaWrapper = styled.div`
  padding: 20px 0;
  text-align: center;
`;



// WEBPACK FOOTER //
// src/app/src/components/SectionProfessional/SectionProfessional.s.ts